module.exports = __webpack_public_path__ + "img/vldmt.04d93b34.png";